export const sentConstants = {

  /*********
   송신함 검색조건 변경
   **********/
  SELECT_SEARCH_REQUEST: 'SELECT_SEARCH_REQUEST',

  /*********
   송신함 목록 조회
   **********/
  SENT_REQUEST: 'GET_SENT_REQUEST',
  SENT_SUCCESS: 'GET_SENT_SUCCESS',
  SENT_FAILURE: 'GET_SENT_FAILURE',

  /*********
   송신함 원본 목록 조회
   **********/
  SENT_ORG_REQUEST: 'GET_SENT_ORG_REQUEST',
  SENT_ORG_SUCCESS: 'GET_SENT_ORG_SUCCESS',
  SENT_ORG_FAILURE: 'GET_SENT_ORG_FAILURE',

  /*********
   송신함 상세 조회
   **********/
  DETAIL_REQUEST: 'GET_DETAIL_REQUEST',
  DETAIL_SUCCESS: 'GET_DETAIL_SUCCESS',
  DETAIL_FAILURE: 'GET_DETAIL_FAILURE',


  /*********
   증명서 상세선택
   **********/
  SELECT_REQUEST: 'SELECT_SENT_REQUEST',

  /***********
   증명서 제출 수신자 SELECT 팝업 오픈
   ************/
  OPEN_RECEIVER_REQUEST: 'OPEN_RECEIVER_REQUEST',

  /***********
   증명서 제출 수신자 추가
   ************/
  ADD_RECEIVER_REQUEST: 'ADD_RECEIVER_REQUEST',

  /***********
   증명서 제출 첨부문서 row 최신화
   ************/
  CHANGE_FILE_REQUEST: 'CHANGE_FILE_REQUEST',

  /*********
   송신함 반려
   **********/
  WITHDRAW_REQUEST: 'WITHDRAW_REQUEST',
  WITHDRAW_SUCCESS: 'WITHDRAW_SUCCESS',
  WITHDRAW_FAILURE: 'WITHDRAW_FAILURE',

  /***********
   증명서 송신함 히스토리 관리
   ************/
  SENT_HISTORY: 'SET_SENT_HISTORY',

  /*********
   송신함 발급 요청
   **********/
  SUB_SENT_DOC_PDF_REQUEST: 'SUB_SENT_DOC_PDF_REQUEST',
  SUB_SENT_DOC_PDF_SUCCESS: 'SUB_SENT_DOC_PDF_SUCCESS',
  SUB_SENT_DOC_PDF_FAILURE: 'SUB_SENT_DOC_PDF_FAILURE',

}
